import { render, staticRenderFns } from "./OfficeRoleCollege.vue?vue&type=template&id=1b3ac782&scoped=true&"
import script from "./OfficeRoleCollege.vue?vue&type=script&lang=js&"
export * from "./OfficeRoleCollege.vue?vue&type=script&lang=js&"
import style0 from "./OfficeRoleCollege.vue?vue&type=style&index=0&id=1b3ac782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3ac782",
  null
  
)

export default component.exports